import React, { useEffect, useState } from "react";
import { libraryStatus, updateLibrary, removeFromLibrary } from "@/lib/api";
import { useAuth, startGoogleLogin } from "@/lib/auth";
import { useLocale } from "@/lib/locale";
import { Button } from "@/components/ui/button";
import { Bookmark, Check, Eye, Star } from "lucide-react";
import { toast } from "sonner";

export default function LibraryActions({ titleId }) {
  const { user } = useAuth() || {};
  const { t } = useLocale();
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (!user) return;
    libraryStatus(titleId).then(setStatus).catch(() => {});
  }, [user, titleId]);

  const setTo = async (s) => {
    if (!user) { startGoogleLogin(); return; }
    if (status === s) {
      await removeFromLibrary(titleId);
      setStatus(null);
      toast.success(t("remove"));
      return;
    }
    await updateLibrary(titleId, s);
    setStatus(s);
    toast.success(s === "watchlist" ? t("in_watchlist") : s === "watched" ? t("marked_watched") : t("following_btn"));
  };

  const baseBtn = "font-heading rounded-md inline-flex items-center gap-1.5 px-3 py-2 text-xs border";
  const idle = "border-white/10 text-zinc-300 hover:border-amber/50 hover:text-amber";
  const active = "border-amber bg-amber/10 text-amber";

  return (
    <div className="flex flex-wrap gap-2" data-testid="library-actions">
      <button
        onClick={() => setTo("watchlist")}
        className={`${baseBtn} ${status === "watchlist" ? active : idle}`}
        data-testid="lib-watchlist"
      >
        <Bookmark className={`h-3.5 w-3.5 ${status === "watchlist" ? "fill-amber" : ""}`} />
        {status === "watchlist" ? t("in_watchlist") : t("add_to_watchlist")}
      </button>
      <button
        onClick={() => setTo("watched")}
        className={`${baseBtn} ${status === "watched" ? active : idle}`}
        data-testid="lib-watched"
      >
        {status === "watched" ? <Check className="h-3.5 w-3.5" /> : <Eye className="h-3.5 w-3.5" />}
        {status === "watched" ? t("marked_watched") : t("mark_watched")}
      </button>
      <button
        onClick={() => setTo("following")}
        className={`${baseBtn} ${status === "following" ? active : idle}`}
        data-testid="lib-following"
      >
        <Star className={`h-3.5 w-3.5 ${status === "following" ? "fill-amber" : ""}`} />
        {status === "following" ? t("following_btn") : t("follow_title")}
      </button>
    </div>
  );
}
